module.exports = __webpack_public_path__ + "static/media/topshape2.82424752.png";